import React from 'react'
import { Page, Text, View, Image, Navigator, PageLoading, Logo, Button, Link } from '@/components'
import { AppImages, Settings } from '@/config'
import { createStyles } from '@codeleap/styles'
import { useLingui } from '@lingui/react/macro'
import { APIClient, ConnectID } from '@/services'

const HomePage = () => {
  const { t } = useLingui()

  const handleSignUp = async () => {
    await ConnectID.ConnectIDAuth.instance.login()

  }

  return (
    <Page
      pageTitle='Home'
      centerContent={false}
      style={[styles.wrapper, { innerWrapper: styles.innerWrapper }]}
      showHeader={false}
    >
      <View
        style={['paddingHorizontal:2',
          'paddingVertical:3',
          'fullHeight',
          'fullWidth ',
          styles.innerWrapper,
          {
            breakpoints: {
              mobile: ['paddingHorizontal:0', 'paddingVertical:0'],
            },
          },
        ]}>
        <View style={['fullWidth', 'relative', 'center', styles.contentArea]}>
          <View style={['absolute', styles.background]}>
            <Image
              source={AppImages.Welcome}
              alt='welcome-background'
              style={styles.backgroundImage}
              objectFit='cover'
            />
          </View>
          <View style={['column', 'gap:8', 'center', styles.contentWrapper]}>
            <View style={['column', 'gap:3', styles.logoWrapper]}>
              <Logo switchServerOnPress debugName='welcome-logo' />
              <Text text='One place to stay connected.' style={['p1', 'textCenter', styles.subTitle]} />
            </View>

            <View style={['column', 'gap:1.5', styles.footer]}>
              <Button text='Log In' onPress={handleSignUp} debugName='welcome-login' style={['xx-large', 'marginHorizontal:5']} />
              <Text style={['p3', 'textCenter', 'color:neutralSolid0', styles.footerTxt]}>
                {t`By signing in to ${Settings.AppName} by ${Settings.CompanyName}, you acknowledge and agree to our `}
                <Link style={['p3', 'link', 'color:neutralSolid0']} to={Settings.ContactINFO.Terms} text={t`Terms`} />
                {t` and `}
                <Link style={['p3', 'link', 'color:neutralSolid0']} to={Settings.ContactINFO.Privacy} text={t`Privacy Policy`} />
              </Text>
            </View>
          </View>
        </View>
      </View>
    </Page>
  )
}

export default () => {
  const { profile, loginResolved } = APIClient.Session.useSession()

  if (!loginResolved) {
    return <PageLoading />
  }

  if (!!profile?.id && loginResolved) {
    return <Navigator.Redirect to='AccessHub.Home' />
  }

  return <HomePage />
}

const styles = createStyles(theme => ({
  wrapper: {
    ...theme.presets.fullHeight,
  },
  innerWrapper: {
    ...theme.presets.fullHeight,
    ...theme.presets.center,
    ...theme.presets.fullWidth,
  },
  contentArea: {
    borderRadius: theme.radius.custom,
    ...theme.presets.fullWidth,
    ...theme.presets.fullHeight,
    overflow: 'hidden',

    [theme.media.down('mobile')]: {
      borderRadius: 0,
    },
  },
  contentWrapper: {
    ...theme.presets.fullHeight,
    zIndex: 2,
  },
  background: {
    ...theme.presets.whole,
  },
  backgroundImage: {
    ...theme.presets.fullWidth,
    ...theme.presets.fullHeight,
  },
  subTitle: {
    fontSize: 20,
    lineHeight: '24px',
    fontWeight: 500,
    color: theme.colors.buttonNeutralPrimaryLabelDefault,
  },
  logoWrapper: {
    [theme.media.down('mobile')]: {
      ...theme.spacing.marginVertical('auto'),
    },
  },
  footer: {
    ...theme.presets.fullWidth,
    maxWidth: 400,

    [theme.media.down('mobile')]: {
      ...theme.spacing.paddingBottom(5),
    },
  },
  footerTxt: {
    color: theme.baseColors.neutralSolid400,

    [theme.media.down('mobile')]: {
      fontSize: 14,
      lineHeight: '18px',
    },
  },
}))
